module.exports = __webpack_public_path__ + "media/images/Useek_Logo_No_DropShadow-b71fbfd5b339ce74903fe7e83f3cb7ae.png";